"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterestType = void 0;
var InterestType;
(function (InterestType) {
    InterestType["COUNTRY"] = "interests_countries";
    InterestType["DISCIPLINE"] = "interests_disciplines";
})(InterestType = exports.InterestType || (exports.InterestType = {}));
